export default __webpack_public_path__ + "static/2_orange-8bb0499ac0bf88b1beb908a95d10c816.svg";